import { defaults } from 'lodash';
import { FrameItem } from '../../../../models/session';
import { Question } from '../../../../models/question';
import { ItemModel } from '../../../../models/itemModel';
import { BoardItemConfig, CreationContext } from './board-item-configurations';

export enum AccessState {
  CanAccess,
  NotInCourse,
  NotInQuestion,
}

export enum BoardQuestionType {
  BoardQuestion = 'questions',
  BoardNote = 'notes',
}

export enum QuestionVisibility {
  ME = 'ME',
  TEACHERS = 'TEACHERS',
  CLASS = 'CLASS',
  PUBLIC = 'PUBLIC',
}
export class BoardQuestionConfigurations extends BoardItemConfig {
  question?: Question;
  courseId: string;
  accessState: AccessState;
  contentId: string;
  questionType: BoardQuestionType;
  showAnswer: boolean;
  showHint: boolean;
  answers: Map<string, string>;
  visibility: QuestionVisibility;

  static defaultBoardItemConfigurations: Partial<BoardItemConfig> = {
    locked: true,
  };

  constructor(
    configurations: Partial<BoardQuestionConfigurations> & Partial<BoardItemConfig>,
    globalCreationParams: CreationContext,
  ) {
    super(
      {
        ...BoardQuestionConfigurations.defaultBoardItemConfigurations,
        ...configurations,
      },
      globalCreationParams,
    );

    const defaultConfigs = {
      courseId: '',
      accessState: AccessState.CanAccess,
      contentId: '',
      questionType: BoardQuestionType.BoardQuestion,
      showAnswer: false,
      showHint: false,
      answers: new Map<string, string>(),
      visibility: QuestionVisibility.ME,
    };

    const questionConfigurations = defaults(configurations, defaultConfigs);

    this.courseId = questionConfigurations.courseId;
    this.accessState = questionConfigurations.accessState;
    this.contentId = questionConfigurations.contentId;
    this.questionType = questionConfigurations.questionType;
    this.showAnswer = questionConfigurations.showAnswer;
    this.showHint = questionConfigurations.showHint;
    this.answers = questionConfigurations.answers;
    this.visibility = questionConfigurations.visibility;
  }

  static fromYCanvasItemObject(
    frameItem: FrameItem,
    globalCreationsParams: CreationContext,
  ): BoardQuestionConfigurations {
    const configurations = BoardItemConfig.fromYCanvasItemObject(
      frameItem,
      globalCreationsParams,
      BoardQuestionConfigurations.defaultBoardItemConfigurations,
    );

    const answersMap = new Map<string, string>();
    for (const [key, value] of Object.entries(frameItem.question_state?.answers ?? {})) {
      answersMap.set(key, value);
    }

    return new BoardQuestionConfigurations(
      {
        ...configurations,
        contentId: frameItem.content_id,
        questionType:
          frameItem.model === ItemModel.Note
            ? BoardQuestionType.BoardNote
            : BoardQuestionType.BoardQuestion,
        showAnswer: frameItem.question_state?.show_answer,
        showHint: frameItem.question_state?.show_hint,
        answers: answersMap,
        visibility: frameItem.question_state?.visibility,
      },
      globalCreationsParams,
    );
  }
}
